export default __webpack_public_path__ + "static/media/ferramentas-bg.34eb63ab.png";